import * as _ from "lodash";
import * as actions from "external/container/actions";
import { initialExternal } from "external/container/External";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
export default function containerReducer(currState = initialExternal, baseAction) {
    let stateChanges;
    switch (baseAction.type) {
        case actions.FETCHING:
            let loadingAction = baseAction;
            stateChanges = {
                isFetchingData: loadingAction.isFetching
            };
            return _.assign({}, currState, stateChanges);
        case actions.AUTHENTICATION:
            let authenticationAction = baseAction;
            stateChanges = {
                isAuthenticatedToView: authenticationAction.isAuthenticated
            };
            return _.assign({}, currState, stateChanges);
        case actions.AUTHORISATION:
            let authorisationAction = baseAction;
            stateChanges = {
                isAuthorisedToView: authorisationAction.isAuthorised
            };
            return _.assign({}, currState, stateChanges);
        case actions.TOKEN_TIME_VALID:
            let timeoutAction = baseAction;
            stateChanges = {
                isTokenTimeValid: timeoutAction.isTokenTimeValid
            };
            return _.assign({}, currState, stateChanges);
        case actions.ERROR:
            let errorAction = baseAction;
            stateChanges = {
                isErrorView: errorAction.isInError
            };
            return _.assign({}, currState, stateChanges);
        case actions.MAINTENANCE:
            let maintenanceAction = baseAction;
            stateChanges = {
                isFetchingData: false,
                isUnderMaintenanceView: maintenanceAction.isUnderMaintenance,
                underMaintenanceMessage: maintenanceAction.underMaintenanceMessage
            };
            return _.assign({}, currState, stateChanges);
        case actions.SHOW:
            stateChanges = {
                isFetchingData: false,
                isAuthenticatedToView: true,
                isAuthorisedToView: true,
                isErrorView: false
            };
            return _.assign({}, currState, stateChanges);
    }
    return currState;
}
